<template>
  <div id="page_news">
    <div class="banner">
      <img src="../assets/img/news_banner.jpg" alt="" class="bg">
      <div class="textbox">
        <h2 class="wow fadeInDown">More About The Acoustics Industry And What's Happening To Brotex</h2>
      </div>
      <div class="crumb">
        <router-link to="./Index">HOME</router-link>
        <router-link to="./News">NEWS</router-link>
      </div>
    </div>
    <div id="part1">
      <div class="item" v-for="(item,index) in newsList" :key="index">
        <img :src="`${$https}${item.articleImg}`" alt="">
        <div class="right">
          <div class="timebox">
            <img src="../assets/img/news_timeicon.png" alt="">
            <span>{{item.timelist}}</span>
          </div>
          <div class="textbox">
            <h3>{{item.name}}</h3>
            <p>{{item.desc}}</p>
            <router-link :to="{path:'./NewsInfo',query:{id:item.id}}" class="mainBtn1 hbutton_isi" target="_blank">LEARN MORE</router-link>
          </div>
        </div>
      </div>
    </div>
    <el-pagination class="pagniation"
       layout="prev, pager, next"
       @current-change="handleCurrentChange"
       :page-size="pageSize"
       :total="total">
    </el-pagination>
  </div>
</template>

<script>
import {WOW} from 'wowjs'
import * as $request from "../api/index";
export default {
  name: "News",
  metaInfo:{
    title:'Guangdong Brotex Acoustic Technology Co.,Ltd | News',
  },
  components:{
  },
  data(){
    return{
      newsList:[],
      pageSize:9,//每页几个
      pageIndex:1,//第几页
      total:0,//总数
    }
  },
  methods:{
    handleCurrentChange(val) {
      this.pageIndex=val
      this.getNews(this.pageIndex,this.pageSize)
    },
    getNews(pageIndex,pageSize){
      $request.getnews(pageIndex,pageSize).then(res=>{
        this.newsList=res.datas
        this.total=res.totalCount
        this.newsList.forEach(val => {
          val.timelist=this.$date(val.releaseDate)
        })
        console.log(this.newsList)
      })

    },
  },
  created() {
    this.$emit('getnav',5)
    this.getNews(this.pageIndex,this.pageSize)
  },
  mounted() {
    this.$nextTick(()=>{
      let wow = new WOW({
        live:false
      })
      wow.init()
    })
  }
}
</script>

<style lang="less" scoped>
#page_news{
  .banner{height: 536px;position: relative;z-index: 1;padding: 230px 0 0 0px;text-align: center;overflow: hidden;
    .bg{position: absolute;bottom: 0;right: 0;z-index: -1;}
    .textbox{
      h2{color: white;width: 55%;margin: 0 auto;}
    }
    .crumb{font: 20px Poppins-SemiBold;margin-top: 60px;
      a{color: white;
        &:not(:last-child):after{content: '>';margin: 0 20px;}
        &:last-child{border-bottom: 1px solid white;}
      }
    }
  }
  #part1{margin: 0;
    .item{position: relative;padding: 110px 280px;border-bottom: 2px solid #E5EAEC;
      img{width: 680px;height: 520px;object-fit: cover;}
      .right{position: absolute;top: calc(50% - 29px);right: 280px;width: 830px;transform: translateY(-50%);
        .timebox{display: flex;justify-content: flex-end;align-items: center;margin-bottom: 20px;
          img{width: auto;height: auto;margin-right: 10px;}
          span{font: 18px Poppins-Regular;color: @main-c5;}
        }
        .textbox{background: #F5F5F5;height: 100%;padding: 60px;
          h3{font-size: 28px;}
          p{margin: 20px 0 30px;}
        }
      }
      &:last-child{border: none;}
      &:nth-child(2n){text-align: right;
        .right{right: unset;left: 280px;text-align: left;
          .timebox{justify-content: flex-start;}
        }
      }
    }
  }
  .pagniation{margin-bottom: 110px;}
}
</style>